import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ factoryParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `factory/getSearched`,
      params: factoryParams,
    });
    const allFactory = data;
    yield put(Actions.setAll({ allFactory }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification(CONSTANT_VARIABLES.ERROR, err, '');
    console.warn(err); // Handle exception
  }
}

function* addorUpdateFactory({ factoryData, actionName, factoryParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(actionName === 'Update' ? api.put : api.post, {
      route: `factory`,
      data: factoryData,
    });
    yield put(Actions.fetchAll({ factoryParams }));
    notification(
      'success',
      actionName === CONSTANT_VARIABLES.ADD ? CONSTANT_VARIABLES.FACTORY_CREATED : CONSTANT_VARIABLES.FACTORY_UPDATED,
      ''
    );
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification(CONSTANT_VARIABLES.ERROR, err.toString(), '');
    console.warn(err); // Handle exception
  }
}

function* deleteFactory({ id, factoryParams }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `factory/${id}`,
    });
    yield put(Actions.fetchAll({ factoryParams }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification(CONSTANT_VARIABLES.ERROR, err.toString(), '');
    console.warn(err); // Handle exception
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(ActionTypes.FETCH_ALL, fetchAll),
    takeLatest(ActionTypes.ADD_OR_UPDATE_FACTORY, addorUpdateFactory),
    takeLatest(ActionTypes.DELETE_FACTORY, deleteFactory),
  ]);
}
